import { createStyles, createTheme, ThemeOptions } from "@material-ui/core/styles";
import createBreakpoints from "@material-ui/core/styles/createBreakpoints";

const breakpoints = createBreakpoints({
  values: {
    xs: 0,
    sm: 600,
    md: 960,
    lg: 1280,
    xl: 1920,
  },
});
export const appTheme: ThemeOptions = createTheme({
  palette: {
    primary: {
      main: "#A72D32",
      light: "#ffffff",
      dark: "#080c11",
    },
    secondary: {
      main: "#C6BA9B",
      light: "#A72D32",
      dark: "#C6BA9B",
    },
  },
  typography: {
    fontFamily: "DiodrumArabic-Bold",
    h1: {
      fontFamily: "DiodrumArabic-Bold",
      [breakpoints.down("md")]: {
        fontSize: "5vmin",
      },
      [breakpoints.up("md")]: {
        fontSize: "2rem",
      },
      fontWeight: 900,
      color: "#C6BA9B",
    },
    h2: {
      [breakpoints.down("md")]: {
        fontSize: "1rem",
      },
      [breakpoints.up("md")]: {
        fontSize: "1.5rem",
      },
      color: "#C6BA9B",
      fontFamily: "DiodrumArabic-Bold",
      fontWeight: 900,
    },
    h3: {
      color: "#C6BA9B",
      [breakpoints.down("md")]: {
        fontSize: "0.5rem",
      },
      [breakpoints.up("md")]: {
        fontSize: "0.75rem",
      },
      fontFamily: "DiodrumArabic-Bold",
      fontWeight: 900,
    },
    h4: {
      [breakpoints.down("sm")]: {
        fontSize: "0.5rem",
      },
      [breakpoints.up("sm")]: {
        fontSize: "1rem",
      },
      fontFamily: "DiodrumArabic-Bold",
      fontWeight: 900,
      color: "#A72D32",
    },

    h6: {},
  },
  breakpoints: {},
  overrides: {
    MuiPaper: createStyles({
      root: {
        backgroundColor:'#E0D6BB',
      },
      asterisk: {
        color: "#FF4949",
        fontFamily: "DiodrumArabic-Bold",
        fontWeight: 900,
      },
    }),
    MuiFormLabel: createStyles({
      root: {
        fontFamily: "DiodrumArabic-Bold",
        fontWeight: 900,
        color: "#CFCFCF",
        "&.Mui-focused": {
          color: "#000000",
        },
      },
      asterisk: {
        color: "#FF4949",
        fontFamily: "DiodrumArabic-Bold",
        fontWeight: 900,
      },
    }),

    MuiFilledInput: createStyles({
      root: {
        backgroundColor: "#ffffff",
        borderRadius: "5px 5px 5px 5px",
        // borderTopLeftRadius: "none",
        // borderTopRightRadius: "none",
        border: '1px solid #A72D32',
        textAlign: "start",
        "&:hover": {
          backgroundColor: "#ffffff",
          border: '1px solid #CE2C2D79',

        },
        "&.Mui-focused": {
          backgroundColor: "#ffffff",
          border: '1px solid #CE2C2D79',
          textAlign: "start",
        },
      },
      underline: {
        "&&:before": {
          borderBottom: "none",
        },
        "&&:after": {
          borderBottom: "none",
        },
      },
    }),
    MuiInput: createStyles({
      root: {
        backgroundColor: "#E0D6BB",
        borderRadius: "5px 5px 5px 5px",
        borderTopLeftRadius: "none",
        borderTopRightRadius: "none",
        // padding: "1% 2%",
      },
      underline: {
        "&&:before": {
          borderBottom: "none",
        },
        "&&:after": {
          borderBottom: "none",
        },
        "&&:hover:not(.Mui-disabled):before": {
          borderBottom: "none",
        },
      },
      // "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button": {
      //   display: "none",
      // },
      // "& input[type=number]": {
      //   MozAppearance: "textfield",
      // },
    }),
    MuiButton: createStyles({
      root: {
        // borderRadius: "15px 15px 15px 15px",
        borderRadius: "5px",
        lineHeight: '1.1876em',
        [breakpoints.down("sm")]: {
          padding: "10px 10px",
          minWidth: "100%",
        },
      },
      containedPrimary: {
        color: 'rgba(355, 355, 355, 1)',
        "&:hover": {
          // @ts-ignore
          backgroundColor: "#A72D32",
          opacity: 0.8,
        },
      },
      label: {
        // marginBottom: "3%",
      },
    }),

    MuiCheckbox: createStyles({
      root: {
        color: "#CFCFCF",
      },
      colorSecondary: {
        "&.Mui-checked": {
          color: "#0176ff",
        },
      },
    }),
    MuiInputLabel: createStyles({
      // root: {
      //   color: '#CE2C2D79', 
      //   '&$focused': {
      //     color: '#000000', 
      //   },
      //   '&$disabled': {
      //     color: '#cccccc', 
      //   },
      // },
      formControl: {
        [breakpoints.down("sm")]: {
          fontSize: "2vmin",
        },
        [breakpoints.up("sm")]: {
          fontSize: "1rem",
        },
        left: "auto",
        right: 0,
        marginRight: "20px",
      },
    }),
    MuiInputBase: createStyles({
      root: {
        [breakpoints.down("sm")]: {
          fontSize: "2vmin",
        },
        [breakpoints.up("sm")]: {
          fontSize: "1rem",
        },
        fontFamily: "DiodrumArabic-Bold",
        fontWeight: 900,
        "&.Mui-disabled": {
          backgroundColor: 'rgba(223, 213, 185, 0.25)',
          border: '1px solid #A72D32',
        }
      },
      input: {
        padding: '12px',
        background: 'rgba(223, 213, 185, 0.25)',
        '&::placeholder': {
          color: '#A72D32', 
          opacity: 1,       
        },
        color: '#A72D32',
      }
    }),
    MuiSelect: createStyles({
      iconFilled: {
        right: "auto",
        left: "7px",
      },
      icon: {
        color: "#A72D32",
        top: 'calc(50% - 8px)',
        [breakpoints.down("sm")]:{
          top: 'calc(50% - 4px)',
        }
      },
    }),
    MuiSvgIcon: createStyles({
      root: {
        fill: '#A72D32',
        [breakpoints.down("sm")]:{
          width: "0.5em",
          height: "0.5em",
        }
      },
      
    }),
    // MuiPopover:createStyles({
    //   paper: {
    //       top: '35px !important', 
    //       left: '211px !important',
    //   },
    // }),
    MuiFormControlLabel: createStyles({
      root: {
        marginRight: "0px",
      },
    }),
    MuiListItem: createStyles({
      root: {
        justifyContent: "flex-end",
        paddingRight: "10px",
        paddingLeft: "10px",
      },
    }),
    MuiCircularProgress: createStyles({
      colorPrimary: {
        color: "#C6BA9B",
      },
    }),
  },
});
